module.exports = __webpack_public_path__ + "img/LogosBlancos.e4021bcb.png";